import React, {useState} from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Error404Img from "../img/404-graphic.png";
import {ButtonLink} from "../components/Button.js";

const StyledAboutIntro = styled.div`
    .row {
        display: flex;
        align-items: center;
    }

    padding: 44px 16px 44px 16px;

    @media (min-width: 768px) {
        padding: 36px 24px 72px 24px;
    }
`;

const AboutIntroLeft = styled.div`
    @media (min-width: 768px) {
        max-width: 550px;
        padding-right: 24px;
    }

    p {
        margin-bottom: 24px;
    }

    h1 {
        &.h2 {
            margin-bottom: 18px;

            @media (min-width: 768px) {
                font-size: 26px;
                margin-bottom: 24px;
            }
            
            @media (min-width: 830px) {
                font-size: 32px;
            }

            span {
                background: ${palette.gradientMain};
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin: 0;
            }
        }
    }
`;

const AboutIntroRight = styled.div`
    width: 100%;
    padding-top: 40px;

    @media (min-width: 768px) {
        padding-top: 0;
        padding-left: 24px;
    }

    img {
        width: 100%;
        object-fit: cover;
        border-radius: 8px;
        max-width: 300px;

        @media (min-width: 768px) {
            max-width: 1000px;
        }
    }
`;

const Error404 = () => {

    return (
        <main>
            <section>
                <StyledAboutIntro>
                    <Container>
                        <Row>
                            <Col xs={12} md={7}>
                                <AboutIntroLeft>
                                    <h1 className={"h2"}>Oops!&nbsp;<span>Nothing to see here.</span></h1>
                                    <p>This page was abducted by aliens and hasn't been seen since. You can stick around as long as you want, but there's more to see when you’re ready.</p>
                                    <ButtonLink text={"Go back home"} to={"/"}></ButtonLink>
                                </AboutIntroLeft>
                            </Col>
                            <Col xs={12} md={5}>
                                <AboutIntroRight>
                                    <img src={Error404Img} alt={"404: page not found"}></img>
                                </AboutIntroRight>
                            </Col>
                        </Row>
                    </Container>
                </StyledAboutIntro>
            </section>
        </main>
    )
}

export default Error404;